import { useParams, Navigate } from 'react-router-dom';
import Events from './Events';
import regionsData from '@/data/regions.json';

const VALID_COUNTRIES = new Set(
  Object.values(regionsData).flatMap(r => r.countries)
);

// Common incorrect-but-tried ISO codes. Data is stored under the
// canonical code so resolve before validating + passing downstream.
const ISO_ALIASES = { UK: 'GB', EL: 'GR' };

const EventsCountry = () => {
  const { iso2 } = useParams();

  if (!iso2) return <Navigate to="/events" replace />;

  const raw = iso2.toUpperCase();
  const upper = ISO_ALIASES[raw] || raw;

  if (!VALID_COUNTRIES.has(upper)) return <Navigate to="/events" replace />;

  // Keyed on the route param so navigating between countries remounts Events
  // and reseeds the country/region filters from the new default.
  return <Events key={upper} defaultCountry={upper} />;
};

export default EventsCountry;
